import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import store from '../store'


export const validationSchemas = () => {
   
  let validationObject = { };
  validationObject["codAmbitoGestion"] = Yup.string().required('Este campo es obligatorio.');
  
  validationObject["idCarpetaResExt"] = Yup.string().test(
    "len",
    "Debe ser menor a 20 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 20);
    }
  );
  return Yup.object().shape(validationObject);
}

